import React from "react";
import styled from "styled-components";
import { fonts, colors, mediaQueries } from "../shared/config";
import SnakerMan from "../images/snakerman.png";

const Container = styled.div`
  background: ${colors.black1};
  /* min-height: 80vh; */
  color: white;
  padding-left: 5vw;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 5vw;
  ${mediaQueries.mobile} {
    grid-template-columns: 1fr;
    justify-content: center;
    padding: 10px;
  }
  ${mediaQueries.tablet} {
    grid-template-columns: 1fr;
    justify-content: center;
    padding: 10px;
  }
  column-gap: 84px;
`;

const Title = styled.div`
  font-size: 48px;
  line-height: 90%;
  font-family: Staatliches;
  margin-top: 93px;
  ${mediaQueries.mobile} {
    margin-top: 40px;
    margin-left: 20px;
  }
  ${mediaQueries.tablet} {
    margin-top: 40px;
    margin-left: 20px;
  }
`;

const Text = styled.div`
  font-family: Cardo;
  font-style: normal;
  font-weight: normal;
  margin-top: 30px;
  font-size: 18px;
  ${mediaQueries.mobile} {
    padding: 20px;
    margin-top: 5px;
  }
  ${mediaQueries.tablet} {
    padding: 20px;
    margin-top: 5px;
  }
`;

const ImageContainer = styled.div`
  padding: 20px;
  width: 100%;
  ${mediaQueries.mobile} {

  }
`;

const Image = styled.img`
  width: 80%;
  margin-top: 42px;
  ${mediaQueries.mobile} {
    width: 100% !important;
    align-items: center !important;
    margin-top: 0;
  }
  ${mediaQueries.tablet} {
    width: 100% !important;
    align-items: center !important;
    margin-top: 0;
  }
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  padding-left: 10px;
  font-size: 12px;
  padding-right: 10px;
  ${mediaQueries.mobile} {
    text-align: right;
  }
  ${mediaQueries.tablet} {
    text-align: right;
  }
`;

const PullQuoteContainer = styled.div`
  background: ${colors.red1};
  min-height: 50vh;
  width: 100%;
  position: relative;
  ${mediaQueries.mobile} {
    padding-bottom: 8px;
    width: 100%;
    min-height: 25vh;
  }
  ${mediaQueries.tablet} {
    padding-bottom: 8px;
    width: 100%;
    min-height: 30vh;
  }
`;

const PullQuoteBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  color: white;
  font-family: Staatliches;
  font-size: 48px;
  line-height: 90%;
  padding: 40px 0;
  ${mediaQueries.mobile} {
    font-size: 30px;
    line-height: 100%;
    padding: 0 !important;
  }
`;



const Quote = styled.div`
  font-family: Staatliches;
  font-style: normal;
  font-weight: normal;
  font-size: 40rem;
  line-height: 90%;
  color: ${colors.black1};
  margin-top: ${(props) => props.mt};
  ${mediaQueries.mobile} {
    display: none;
  }
  ${mediaQueries.tablet} {
    display: none;
  }
`;

const QuoteTxt = styled.p`
font-size: 35px;
 ${mediaQueries.mobile} {
    text-align: center;
    font-size: 26px;
  }
  ${mediaQueries.mobile} {
    text-align: center;
    font-size: 26px;
  }
`;

const QuoteContainer = styled.div`
  display: flex;
  height: 400px;
  ${mediaQueries.mobile} {
    /* height: 180px; */
    padding:10px;
    margin: auto;
  }
  ${mediaQueries.tablet} {
    padding: 20px;
    margin: auto;
  }
`;

export default function Profile(props) {
  return(
      <>
      {props.data.map(block=>{
        switch(block.type){
          case 'quote':
            return(
                    <PullQuoteContainer>
                    <PullQuoteBox>
                      <QuoteContainer>
                        <Quote mt="-80px">“</Quote>
                        <QuoteTxt style={{ alignSelf: "center" }}>
                          {block.content}
                        </QuoteTxt>
                        <Quote mt="170px">”</Quote>
                      </QuoteContainer>
                    </PullQuoteBox>
                  </PullQuoteContainer>
            )
            default:
              console.log("hello");
            
          }})}
      <Container>
        <div>
        {props.data.map(block=>{
          if(block.type === "paragraph"){
            return(
              <Text>{block.content}</Text>
            )
          }

          })} 

        </div>
        <ImageContainer>
          {props.data.map(block=>{
            if(block.type === "image"){
              return(
                <>
                  <Image src={block.image_link} alt="snakerman"></Image>
                  <Credits> {block.image_credits} </Credits>
                </>
              )
            }

            })} 

        </ImageContainer>
        
       

      </Container>
      
      </>
  )};

